// eslint-disable-next-line no-undef
const universalEnv = typeof window !== 'undefined' && window.process ? window.process.env : process.env;

export default universalEnv;
